module.exports = __webpack_public_path__ + "img/Arrow.f1845186.svg";